import { ua } from '@weapp/utils';
import { AnyObj } from '../../../lib';

const customCache = new Set<string>();

/**
 * Generates an SVG sprite from a string of SVG contents.
 * @param {string} contents - The string of SVG contents.
 * @param {string} [iconName] - An optional string that is used to generate an ID for the SVG sprite.
 * @returns {string} A string that represents the SVG sprite.
 */
export const svgSprite = (contents: string, iconName?: string) => `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    id="_WEAPP_UI_ICON_SVG_REFS_NODE_${iconName?.toUpperCase()}"
    style="position:absolute;width:0;height:0"
  >
    <defs>
      ${contents}
    </defs>
  </svg>
`;

function isValidCustomScriptUrl(scriptUrl: string): boolean {
  return Boolean(
    typeof scriptUrl === 'string'
    && scriptUrl.length
    && !customCache.has(scriptUrl)
  );
}

/**
 * Creates script elements from an array of script URLs.
 * @param {string[]} scriptUrls - An array of script URLs.
 * @param {number} [index=0] - An optional number that is used to keep track of the current index in the `scriptUrls` array.
 * @returns {void}
 */
export function createScriptUrlElements(scriptUrls: string[], index: number = 0): void {
  const currentScriptUrl = scriptUrls[index];
  if (isValidCustomScriptUrl(currentScriptUrl)) {
    const script = document.createElement('script');
    script.setAttribute('src', currentScriptUrl);
    script.setAttribute('data-namespace', currentScriptUrl);
    if (scriptUrls.length > index + 1) {
      script.onload = () => {
        createScriptUrlElements(scriptUrls, index + 1);
      };
      script.onerror = () => {
        createScriptUrlElements(scriptUrls, index + 1);
      };
    }
    customCache.add(currentScriptUrl);
    document.body.appendChild(script);
  }
}


/** 小写 iconName 映射表 */
export function toIconNameLowerMap(obj: AnyObj) {
  let lowerMap: { [key: string]: string } = {};
  Object.keys(obj).forEach(key => {
    lowerMap[key.toLocaleLowerCase()] = key;
  })
  return lowerMap;
}
